import React from "react";

function Banner() {
  return (
    <div>
      <div className="bg-primary px-4 py-4 md:py-3.5 lg:py-[16.5px] text-center text-surface-white">
        <p className="font-medium text-xs xl:text-sm leading-normal sm:leading-none inline-flex items-center justify-center gap-x-2.5">
          <span className="size-3 xl:size-[15px] rounded-full bg-[#16b52a] shrink-0" />
          Now accepting pilot sign-ups- Limited spots available for early
          supporters
        </p>
      </div>
    </div>
  );
}

export default Banner;
